import { request, success, failure, SUGGESTION_REQUEST } from "./utilities";
import { getSuggestions, makeSuggestion } from "../api";
import { SuggestionData } from "../../utils/dummyData";

export function getAllSuggestions() {
    return (dispatch) => {
        dispatch(success(SUGGESTION_REQUEST.GET_SUGGESTIONS_SUCCESS, SuggestionData));
        // dispatch(request(SUGGESTION_REQUEST.GET_SUGGESTIONS_REQUEST));
        // getSuggestions().then((res) => {
        //     if (res.data.status === 1) {
        //         dispatch(success(SUGGESTION_REQUEST.GET_SUGGESTIONS_SUCCESS, res.data.data));
        //     }
        //     else {
        //         dispatch(failure(SUGGESTION_REQUEST.GET_SUGGESTIONS_FAILURE, res.data.message));
        //     }
        // }, (error) => {
        //     dispatch(failure(SUGGESTION_REQUEST.GET_SUGGESTIONS_FAILURE, (error && error.response && error.response.data && error.response.data.title ? error.response.data.title : error.message)));
        // })
    }
}

export function addSuggestion(data) {
    return (dispatch) => {
        dispatch(request(SUGGESTION_REQUEST.ADD_SUGGESTIONS_REQUEST));
        makeSuggestion(data).then((res) => {
            if (res.data.status === 1) {
                dispatch(success(SUGGESTION_REQUEST.ADD_SUGGESTIONS_SUCCESS, res.data.data));
            }
            else {
                dispatch(failure(SUGGESTION_REQUEST.ADD_SUGGESTIONS_FAILURE, res.data.message));
            }
        }, (error) => {
            dispatch(failure(SUGGESTION_REQUEST.ADD_SUGGESTIONS_FAILURE, (error && error.response && error.response.data && error.response.data.title ? error.response.data.title : error.message)));
        })
    }
}